export default class {
    constructor(common) {
        this.common = common;
        this.view = document.querySelector('body#company');

        if (this.view) {
            this.init();
        }
    }

    init() {
        this.view.map = this.view.querySelector('.map');
        this.view.map.iframe = this.view.map.querySelector('iframe');

        // レスポンシブイベントのリスナーを追加
        window.addEventListener('resize:responsive', () => {
            this.responsive();
        });

        this.responsive(); // 初期化時に呼び出し
    }

    responsive() {
        if (this.common.media('PC')) {
            this.view.map.iframe.src = this.view.map.iframe.dataset.mapPc;
        }
        if (this.common.media('SP')) {
            this.view.map.iframe.src = this.view.map.iframe.dataset.mapSp;
        }
    }
}
